import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  AI_PROMPT_BUILDER_COLLECTIONS_WITH_PROMPT_BEGIN,
  AI_PROMPT_BUILDER_COLLECTIONS_WITH_PROMPT_SUCCESS,
  AI_PROMPT_BUILDER_COLLECTIONS_WITH_PROMPT_FAILURE,
  AI_PROMPT_BUILDER_COLLECTIONS_WITH_PROMPT_DISMISS_ERROR,
} from './constants';
import { toast } from 'react-toastify';

export function collectionsWithPrompt(args = {}) {
  return (dispatch) => {
    dispatch({
      type: AI_PROMPT_BUILDER_COLLECTIONS_WITH_PROMPT_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_AI_ENGINE}v${version}/generate-collection/prompt`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: AI_PROMPT_BUILDER_COLLECTIONS_WITH_PROMPT_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: AI_PROMPT_BUILDER_COLLECTIONS_WITH_PROMPT_FAILURE,
            data: { error: err },
          });
          reject(err);
          let errorMsg = 'An unexpected error occurred. Please try again.';
          if (err && err.response && err.response.data && err.response.data.error) {
            errorMsg = err.response.data.error;
          }
          toast.error(errorMsg, {});
        },
      );
    });

    return promise;
  };
}

export function dismissCollectionsWithPromptError() {
  return {
    type: AI_PROMPT_BUILDER_COLLECTIONS_WITH_PROMPT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case AI_PROMPT_BUILDER_COLLECTIONS_WITH_PROMPT_BEGIN:
      return {
        ...state,
        collectionsWithPromptPending: true,
        collectionsWithPromptError: null,
      };

    case AI_PROMPT_BUILDER_COLLECTIONS_WITH_PROMPT_SUCCESS:
      return {
        ...state,
        collectionsWithPromptPending: false,
        collectionsWithPromptError: null,
        promptCollections: action.data,
      };

    case AI_PROMPT_BUILDER_COLLECTIONS_WITH_PROMPT_FAILURE:
      return {
        ...state,
        collectionsWithPromptPending: false,
        collectionsWithPromptError: action.data.error,
      };

    case AI_PROMPT_BUILDER_COLLECTIONS_WITH_PROMPT_DISMISS_ERROR:
      return {
        ...state,
        collectionsWithPromptError: null,
      };

    default:
      return state;
  }
}
